import React from 'react';
import { Box, Text } from '@qga/roo-ui/components';

const PackageUnavailable = () => {
  return (
    <>
      <Box mt="4">
        <Text fontSize="md" color="orange" fontWeight="bold">
          Unavailable
        </Text>
      </Box>
      <Box mt="2">
        <Text fontSize="sm">This package is not available.</Text>
      </Box>
    </>
  );
};

export default PackageUnavailable;
